const apiUrl = "https://admision.tec.mx/costo-de-vida/api/calculadora_vida/"
//const apiUrl = "http://localhost/api/calculadora_vida/"
export{apiUrl}